import React from "react";
import { Box, Typography } from "@mui/material";
import LightbulbIcon from "@mui/icons-material/Lightbulb";

const SearchTips = ({ isMobile }) => {
  return (
    <Box sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      maxWidth: isMobile ? "90vw" : "800px",
      mx: "auto",
      mt: isMobile ? 1.5 : 3,
      mb: isMobile ? 2 : 0,
      gap: isMobile ? 1 : 1.2,
    }}>
      <Box sx={{ display: "flex", alignItems: "flex-start", mb: 0 }}>
        <LightbulbIcon sx={{ color: "#A0C49D", mr: 1, fontSize: isMobile ? 20 : 26, mt: -0.1 }} />
        <Typography sx={{ color: "#526D50", fontSize: isMobile ? 12 : 15, lineHeight: 1.5 }}>
          To increase search accuracy, make sure to include the last known date and location of your lost item.
        </Typography>
      </Box>
      <Box sx={{ display: "flex", alignItems: "flex-start" }}>
        <LightbulbIcon sx={{ color: "#A0C49D", mr: 1, fontSize: isMobile ? 20 : 26, mt: -0.1 }} />
        <Typography sx={{ color: "#526D50", fontSize: isMobile ? 12 : 15, lineHeight: 1.5 }}>
          UFind currently supports English searches only. Using other languages may lead to no results.
        </Typography>
      </Box>
    </Box>
  );
};

export default SearchTips;
